import { Box, Typography } from '@mui/material';

import { CARD_SX, DASH } from '../tokens';

export interface LicenseRosteringBarProps {
  licenses: number | null;
  rostered: number;
}

const BODY_1 = { fontSize: '16px', lineHeight: '24px' } as const;

function Count({ value, label }: { value: number; label: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Typography component="span" sx={{ ...BODY_1, fontWeight: 700, color: DASH.ink }}>
        {String(value)}
      </Typography>
      <Typography component="span" sx={{ ...BODY_1, fontWeight: 500, color: DASH.muted }}>
        {label}
      </Typography>
    </Box>
  );
}

export function LicenseRosteringBar({ licenses, rostered }: LicenseRosteringBarProps) {
  return (
    <Box
      data-testid="license-rostering-bar"
      sx={{
        ...CARD_SX,
        p: '16px 24px',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '32px',
      }}
    >
      <Typography component="span" sx={{ ...BODY_1, fontWeight: 700, color: DASH.ink }}>
        Licenses &amp; Rostering
      </Typography>
      {licenses === null ? (
        <Typography component="span" sx={{ ...BODY_1, fontWeight: 500, color: DASH.muted }}>
          Site license
        </Typography>
      ) : (
        <Count value={licenses} label="Flashlight licenses" />
      )}
      <Count value={rostered} label="Flashlight rostered students" />
    </Box>
  );
}
